"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toSplicedArray = exports.mod = exports.assertAndGet = exports.validateDateFormat = exports.getDateTimeFormat = exports.getTimeFormat = exports.getDateFormat = exports.TimeFormatArray = exports.DateSeparatorLabelArray = exports.DateFormatTypeArray = exports.DateFormatIsoArray = exports.DateFormatFormArray = exports.convertDateSeparator = exports.enumConverter = exports.getEnumValuesArray = exports.flattenObject = exports.middleTruncate = exports.sliceIntoChunks = void 0;
const lodash_1 = __importDefault(require("lodash"));
const enums_1 = require("./enums");
//#region Arrays
function sliceIntoChunks(arr, chunkSize) {
    const res = [];
    for (let i = 0; i < arr.length; i += chunkSize) {
        const chunk = arr.slice(i, i + chunkSize);
        res.push(chunk);
    }
    return res;
}
exports.sliceIntoChunks = sliceIntoChunks;
//#endregion
function middleTruncate(value, length) {
    if (value && typeof value === 'string') {
        const requiredLength = length || 30;
        if (value && value.length - 3 > requiredLength) {
            return [
                value === null || value === void 0 ? void 0 : value.slice(0, Math.abs(requiredLength / 2)),
                '...',
                value === null || value === void 0 ? void 0 : value.slice(Math.abs(value.length - requiredLength / 2)),
            ].join('');
        }
    }
    return value;
}
exports.middleTruncate = middleTruncate;
function flattenObject(o, prefix = '', result = {}, keepNull = true) {
    if (lodash_1.default.isString(o) || lodash_1.default.isNumber(o) || lodash_1.default.isBoolean(o) || (keepNull && lodash_1.default.isNull(o))) {
        result[prefix] = o;
        return result;
    }
    if (lodash_1.default.isArray(o) || lodash_1.default.isPlainObject(o)) {
        for (const i in o) {
            let pref = prefix;
            if (lodash_1.default.isArray(o)) {
                pref = pref + `[${i}]`;
            }
            else {
                if (lodash_1.default.isEmpty(prefix)) {
                    pref = i;
                }
                else {
                    pref = prefix + '.' + i;
                }
            }
            flattenObject(o[i], pref, result, keepNull);
        }
        return result;
    }
    return result;
}
exports.flattenObject = flattenObject;
//#region Enums
const getEnumValuesArray = (enumType) => Object.values(enumType);
exports.getEnumValuesArray = getEnumValuesArray;
/*
  Create a converter for enums with like keys and unique values. If values are not unique, the first match will be used as the like key.
  Usage, wherein ENUM1, ENUM2, ENUM3, ... are enums with like keys, each with unique values:
    export const convertEnumSets = enumConverter(ENUM1, ENUM2, ENUM3, ...);
    let enum2Result = convertEnumSets(enum1Value, ENUM1, ENUM2);
    let enum1Result = convertEnumSets(enum3Value, ENUM3, ENUM1);
*/
const enumConverter = (..._) => (fromValue, fromEnum, toEnum) => {
    var _a;
    const enumKey = (_a = Object.entries(fromEnum).find(([_, v]) => v === fromValue)) === null || _a === void 0 ? void 0 : _a[0];
    return toEnum[enumKey];
};
exports.enumConverter = enumConverter;
exports.convertDateSeparator = (0, exports.enumConverter)(enums_1.DATE_SEPARATOR, enums_1.DATE_SEPARATOR_NAME, enums_1.DATE_SEPARATOR_LABEL);
//#endregion
//#region DateTime
exports.DateFormatFormArray = (0, exports.getEnumValuesArray)(enums_1.DATE_FORMAT_FORM);
exports.DateFormatIsoArray = (0, exports.getEnumValuesArray)(enums_1.DATE_FORMAT_ISO);
exports.DateFormatTypeArray = (0, exports.getEnumValuesArray)(enums_1.DATE_FORMAT_TYPE);
exports.DateSeparatorLabelArray = (0, exports.getEnumValuesArray)(enums_1.DATE_SEPARATOR_LABEL);
exports.TimeFormatArray = (0, exports.getEnumValuesArray)(enums_1.TIME_FORMAT);
const getDateFormatParts = (dateFormatType, dateFormat, timeFormat, isoSplitter) => {
    var _a;
    switch (dateFormatType) {
        case enums_1.DATE_FORMAT_TYPE.ISO8601:
            isoSplitter = (isoSplitter !== null && isoSplitter !== void 0 ? isoSplitter : dateFormat.indexOf('T') !== -1) ? 'T' : ' ';
            const isoParts = dateFormat.split(isoSplitter);
            return { date: isoParts[0], time: (_a = isoParts[1]) !== null && _a !== void 0 ? _a : enums_1.DEFAULT_DATETIME_FORMAT.TimeFormat, splitter: isoSplitter };
        case enums_1.DATE_FORMAT_TYPE.GeneralForm:
            return { date: dateFormat, time: timeFormat };
        default:
            return { date: dateFormat, time: 'LT' }; // Local Time
    }
};
// TODO: Rewrite as reusable method?
const convertDateFormatToMoment = (dateFormatType, dateFormat) => {
    const convertedFormat = dateFormat
        .replace(/d/g, 'D') // Convert "Day of Month" to MomentJS representation.
        .replace(/y/g, 'Y'); // Convert "Year" to MomentJS representation.
    switch (dateFormatType) {
        case enums_1.DATE_FORMAT_TYPE.ISO8601:
            return convertedFormat.replace(/h/g, 'H'); // Convert ISO "24-hour" to MomentJS representation.
        case enums_1.DATE_FORMAT_TYPE.GeneralForm:
            return convertedFormat.replace(/m/g, 'M'); // Convert MomentJS "Minute" to "Month".
        default:
            return convertedFormat;
    }
};
const convertTimeFormatToMoment = (dateFormatType, dateFormat, timeFormat) => {
    const convertedFormat = getDateFormatParts(dateFormatType, dateFormat, timeFormat)
        .time.replace(/d/g, 'D') // Convert "Day of Month" to MomentJS representation.
        .replace(/y/g, 'Y'); // Convert "Year" to MomentJS representation.
    switch (dateFormatType) {
        case enums_1.DATE_FORMAT_TYPE.ISO8601:
            return convertedFormat.replace(/h/g, 'H'); // Convert ISO "24-hour" to MomentJS representation.
        case enums_1.DATE_FORMAT_TYPE.GeneralForm:
            return convertedFormat.replace(/M/g, 'm'); // Convert MomentJS "Month" to "Minute".
        default:
            return convertedFormat;
    }
};
const convertDateFormatToPicker = (dateFormatType, dateFormat) => {
    const convertedFormat = dateFormat
        .replace(/D/g, 'd') // Convert "Day of Month" to MUI Picker representation.
        .replace(/Y/g, 'y'); // Convert "Year" to MUI Picker representation.
    switch (dateFormatType) {
        case enums_1.DATE_FORMAT_TYPE.ISO8601:
            return convertedFormat.replace(/h/g, 'H'); // Convert ISO "24-hour" to MUI Picker representation.
        case enums_1.DATE_FORMAT_TYPE.GeneralForm:
            return convertedFormat.replace(/m/g, 'M'); // Convert MUI Picker "Minute" to "Month".
        default:
            return convertedFormat;
    }
};
const convertTimeFormatToPicker = (dateFormatType, dateFormat, timeFormat) => {
    const convertedFormat = getDateFormatParts(dateFormatType, dateFormat, timeFormat)
        .time.replace(/D/g, 'd') // Convert "Day of Month" to MUI Picker representation.
        .replace(/Y/g, 'y'); // Convert "Year" to MUI Picker representation.
    switch (dateFormatType) {
        case enums_1.DATE_FORMAT_TYPE.ISO8601:
            return convertedFormat
                .replace(/h/g, 'H') // Convert ISO "24-hour" to MUI Picker representation.
                .replace(/Z/g, ''); // Remove timezone representation.
        case enums_1.DATE_FORMAT_TYPE.GeneralForm:
            return convertedFormat.replace(/M/g, 'm'); // Convert MUI Picker "Month" to "Minute".
        default:
            return convertedFormat;
    }
};
const convertDateFormat = (dateFormatType, dateFormat, tokenConversion) => {
    switch (tokenConversion) {
        case enums_1.DATETIME_TOKEN_CONVERSION.MomentJS:
            return convertDateFormatToMoment(dateFormatType, dateFormat);
        case enums_1.DATETIME_TOKEN_CONVERSION.MuiPicker:
            return convertDateFormatToPicker(dateFormatType, dateFormat);
        default:
            return dateFormat;
    }
};
const convertTimeFormat = (dateFormatType, dateFormat, timeFormat, tokenConversion) => {
    switch (tokenConversion) {
        case enums_1.DATETIME_TOKEN_CONVERSION.MomentJS:
            return convertTimeFormatToMoment(dateFormatType, dateFormat, timeFormat);
        case enums_1.DATETIME_TOKEN_CONVERSION.MuiPicker:
            return convertTimeFormatToPicker(dateFormatType, dateFormat, timeFormat);
        default:
            return getDateFormatParts(dateFormatType, dateFormat, timeFormat).time;
    }
};
const getDateFormatWithSeparator = (dateFormat, dateSeparator) => {
    var _a;
    return dateFormat.replace(/\s+/g, (_a = (0, exports.convertDateSeparator)(dateSeparator, enums_1.DATE_SEPARATOR_LABEL, enums_1.DATE_SEPARATOR)) !== null && _a !== void 0 ? _a : enums_1.DATE_SEPARATOR.Space);
};
const getDateFormat = (dateFormatType = enums_1.DEFAULT_DATETIME_FORMAT.DateFormatType, dateFormat = enums_1.DEFAULT_DATETIME_FORMAT.DateFormat, dateSeparator = enums_1.DEFAULT_DATETIME_FORMAT.DateSeperator.toString(), options) => {
    const convertedFormat = convertDateFormat(dateFormatType, (options === null || options === void 0 ? void 0 : options.datePartOnly) ? getDateFormatParts(dateFormatType, dateFormat).date : dateFormat, options === null || options === void 0 ? void 0 : options.tokenConversion);
    switch (dateFormatType) {
        case enums_1.DATE_FORMAT_TYPE.ISO8601:
            return convertedFormat;
        case enums_1.DATE_FORMAT_TYPE.GeneralForm:
            return getDateFormatWithSeparator(convertedFormat, dateSeparator);
        default:
            return convertedFormat;
    }
};
exports.getDateFormat = getDateFormat;
const getTimeFormat = (dateFormatType = enums_1.DEFAULT_DATETIME_FORMAT.DateFormatType, dateFormat = enums_1.DEFAULT_DATETIME_FORMAT.DateFormat, timeFormat = enums_1.DEFAULT_DATETIME_FORMAT.TimeFormat, options) => {
    let timeFormatForm;
    switch (timeFormat) {
        case enums_1.TIME_FORMAT.Clock12Hr:
            timeFormatForm = enums_1.TIME_FORMAT_FORM.HH_MM_A;
            break;
        case enums_1.TIME_FORMAT.Clock24Hr:
            timeFormatForm = enums_1.TIME_FORMAT_FORM.HH_MM;
            break;
        default:
            timeFormatForm = enums_1.DEFAULT_DATETIME_FORMAT.TimeFormatForm;
            break;
    }
    return convertTimeFormat(dateFormatType, dateFormat, timeFormatForm, options === null || options === void 0 ? void 0 : options.tokenConversion);
};
exports.getTimeFormat = getTimeFormat;
const getDateTimeFormat = (dateFormatType = enums_1.DEFAULT_DATETIME_FORMAT.DateFormatType, dateFormat = enums_1.DEFAULT_DATETIME_FORMAT.DateFormat, dateSeparator = enums_1.DEFAULT_DATETIME_FORMAT.DateSeperator.toString(), timeFormat = enums_1.DEFAULT_DATETIME_FORMAT.TimeFormat, options, isSwitch = false // Don't use default setting; opt-in only.
) => {
    if (isSwitch) {
        dateFormatType = enums_1.DATE_FORMAT_TYPE.ISO8601;
        dateFormat = enums_1.DATE_FORMAT_ISO.YYYY_MM_DDTHH_MM_SSZ;
    }
    const convertedDateFormat = (0, exports.getDateFormat)(dateFormatType, dateFormat, dateSeparator, Object.assign({ datePartOnly: false }, options));
    switch (dateFormatType) {
        case enums_1.DATE_FORMAT_TYPE.ISO8601:
            return convertedDateFormat;
        case enums_1.DATE_FORMAT_TYPE.GeneralForm:
            return `${convertedDateFormat} ${(0, exports.getTimeFormat)(dateFormatType, dateFormat, timeFormat, options)}`;
        default:
            return convertedDateFormat;
    }
};
exports.getDateTimeFormat = getDateTimeFormat;
const validateDateFormat = (dateFormatType, dateFormat) => {
    switch (dateFormatType) {
        case enums_1.DATE_FORMAT_TYPE.ISO8601:
            return exports.DateFormatIsoArray.includes(dateFormat) ? dateFormat : enums_1.DEFAULT_DATE_FORMAT.ISO;
        case enums_1.DATE_FORMAT_TYPE.GeneralForm:
            return exports.DateFormatFormArray.includes(dateFormat) ? dateFormat : enums_1.DEFAULT_DATE_FORMAT.Form;
        default:
            return undefined; // DEFAULT_DATETIME_FORMAT.DateFormat;
    }
};
exports.validateDateFormat = validateDateFormat;
//#endregion
/**
 * Asserts value, and throws an exception on failure to assert.
 * @param value The value to check.
 * @param [errorMessage] The message to be used for the exception if `value` cannot be asserted.
 * @param [comparator] The function to be used to assert `value`. Default: `value` is not `null` or `undefined`.
 * @returns Returns `value`.
 */
const assertAndGet = (value, errorMessage, comparator) => {
    comparator = comparator !== null && comparator !== void 0 ? comparator : (v => !lodash_1.default.isNil(v));
    if (!comparator(value)) {
        const e = typeof errorMessage === 'string' ? errorMessage : errorMessage === null || errorMessage === void 0 ? void 0 : errorMessage(value);
        throw e !== null && e !== void 0 ? e : 'Assertion failed.';
    }
    return value;
};
exports.assertAndGet = assertAndGet;
const mod = (number1, number2) => {
    return ((number1 % number2) + number2) % number2;
};
exports.mod = mod;
/**
 * This helper method replicates `Array<T>.toSpliced` from `lib.es2023.array.d.ts`; Node 18 and Typescript versions <5.5.0 conflict.
 * https://github.com/microsoft/TypeScript/issues/56303
 * https://github.com/microsoft/TypeScript/issues/57683
 * https://github.com/typescript-eslint/typescript-eslint/pull/9113
 * https://github.com/tsconfig/bases/issues/217
 * Copies an array and removes elements and, if necessary, inserts new elements in their place. Returns the copied array.
 * @param array The array from which to remove elements.
 * @param start The zero-based location in the array from which to start removing elements.
 * @param deleteCount The number of elements to remove.
 * @param items Elements to insert into the copied array in place of the deleted elements.
 * @returns The copied array.
 */
const toSplicedArray = (array, start, deleteCount, ...items) => {
    const copiedArray = [...array];
    copiedArray.splice(start, deleteCount, ...items);
    return copiedArray;
};
exports.toSplicedArray = toSplicedArray;
